import { istNow, toIst } from "../../utils/istTime";

// Every chat timestamp is rendered in Indian time, so day comparisons have to
// use an Indian "now" as well or the boundaries would follow the device zone.
const isSameDay = (date, reference) => date.isSame(reference, "day");

/**
 * Short timestamp for the conversation list: time for today, "Yesterday",
 * the weekday within the last week, then a date.
 */
export const formatListTime = (value) => {
  const date = toIst(value);
  if (!date) return "";
  if (isSameDay(date, istNow())) return date.format("LT");
  if (isSameDay(date, istNow().subtract(1, "day"))) return "Yesterday";
  if (date.isAfter(istNow().subtract(7, "days"))) return date.format("ddd");
  return date.format("DD/MM/YY");
};

/** Clock time shown on a message bubble. */
export const formatMessageTime = (value) => {
  const date = toIst(value);
  return date ? date.format("LT") : "";
};

/** Label for the date separator above the first message of each day. */
export const formatDayLabel = (value) => {
  const date = toIst(value);
  if (!date) return "";
  if (isSameDay(date, istNow())) return "Today";
  if (isSameDay(date, istNow().subtract(1, "day"))) return "Yesterday";
  if (date.isSame(istNow(), "year")) return date.format("D MMMM");
  return date.format("D MMMM YYYY");
};

/** Groups messages into Indian-time date buckets; "" without a timestamp. */
export const dayKey = (value) => {
  const date = toIst(value);
  return date ? date.format("YYYY-MM-DD") : "";
};

/** Avatar fallback for profiles without an uploaded image. */
export const initialsOf = (name) => (name || "").trim().charAt(0).toUpperCase();

/**
 * Presence text for the chat header. `last_seen` stays null until the peer
 * has connected at least once, so fall back to a plain offline label.
 */
export const presenceLabel = (participant, isOnline) => {
  if (isOnline) return "Online";
  const date = toIst(participant?.last_seen);
  if (!date) return "Offline";
  if (isSameDay(date, istNow())) return `Last seen today at ${date.format("LT")}`;
  if (isSameDay(date, istNow().subtract(1, "day")))
    return `Last seen yesterday at ${date.format("LT")}`;
  return `Last seen ${date.format("DD/MM/YY")}`;
};
